export const YEAR_EURO_WAS_INTRODUCED = 2023
